import React from "react";
import {
  EpDevPUtils,
  IEpDevPEnvironment4IndexableDocument,
  TEpDevPEntityId,
} from "@solace-labs/backstage-plugin-ep-devp-common";
import { EpDevPSearchFilterCheckbox } from "../EpDevPSearchFilters";
import { useServiceRegistryTranslation } from '../../../../../i18n/ServiceRegistryLanguageProvider';

/** @alpha */
export type EpDevPSearchFilterEnvironmentsProps = {
  environments: Array<TEpDevPEntityId>;
  className?: string;
}

/** @alpha */
export const EpDevPSearchFilterEnvironments = (props: EpDevPSearchFilterEnvironmentsProps) => {
  const { t } = useServiceRegistryTranslation();

  const SearchFieldName = "environmentIdList" as const;
  const { environments, className } = props;
  return (
    <EpDevPSearchFilterCheckbox
      className={className}
      title={t('developerSearch.environments')}
      searchFieldName={EpDevPUtils.nameOf<IEpDevPEnvironment4IndexableDocument>(SearchFieldName)}
      valuesEntityIdList={environments}
    />
  );
}
